<!--
* @description  参数1
* @fileName  index
* @author userName
* @date 2024-01-15 11:59:53
!-->
<template>
  <div id="index" class="index">
    <div class="Steps-main">
      <Steps :active="active" :is-bj="true" />
    </div>
    <div class="booking-title"><span>┃</span><span>Booking Summary</span></div>
    <div class="booking-content">
      <div class="content-l">
        <div v-if="data.orderServiceType==1" class="start-end">
          <div class="city-name-top" >
            <span><img class="package-img" src="@/assets/img/client/chat/car.png" width="24px"
            height="24px"></span>
            <span>{{ data.departureCode }}</span>
            <span><img src="@/assets/img/client/check/Air.png" style="width: 24px;"></span>
            <span>{{ data.destinationCode }}</span>
            <span><img class="package-img" src="@/assets/img/client/chat/car.png" width="24px"
            height="24px"></span>
          </div>
          <div class="route">
            <img src="@/assets/img/client/booking/dian-icon.png" width="16px" height="16px">
            <div class="line" style="width: 180px;margin: 7px 10px 0;" />
            <img src="@/assets/img/client/booking/dian-icon.png" width="16px" height="16px">
            <div class="line" style="width: 180px;margin: 7px 10px 0;border-style: solid" />
            <img src="@/assets/img/client/booking/dian-icon.png" width="16px" height="16px">
            <div class="line" style="width: 180px;margin: 7px 10px 0;" />
            <img src="@/assets/img/client/booking/dian-icon.png" width="16px" height="16px">
          </div>
          <div class="city-name">
            <span>{{GetOriginAddress() }}</span>
            <span>{{ GetDestAddress() }}</span>
          </div>
        </div>
        <div v-if="data.orderServiceType==2" class="start-end">
          <div class="city-name-top" style="width: 70%;margin: 0 22%;" >
            <span><img class="package-img" src="@/assets/img/client/chat/car.png" width="24px"
            height="24px"></span>
            <span>{{ data.departureCode }}</span>
            <span><img src="@/assets/img/client/check/Air.png" style="width: 24px;"></span>
            <span>{{ data.destinationCode }}</span>
          </div>
          <div class="route">
            <img src="@/assets/img/client/booking/dian-icon.png" width="16px" height="16px">
            <div class="line" style="width: 280px;margin: 7px 10px 0;" />
            <img src="@/assets/img/client/booking/dian-icon.png" width="16px" height="16px">
            <div class="line" style="width: 280px;margin: 7px 10px 0;border-style: solid" />
            <img src="@/assets/img/client/booking/dian-icon.png" width="16px" height="16px">
          </div>
          <div class="city-name">
            <span>{{GetOriginAddress() }}</span>
          </div>
        </div>
        <div v-if="data.orderServiceType==3"  class="start-end">
          <img class="package-img" src="@/assets/img/client/check/Air.png" width="24px"
            height="24px">
          <div class="route">
            <img src="@/assets/img/client/booking/dian-icon.png" width="16px" height="16px">
            <div class="line" />
            <img src="@/assets/img/client/booking/dian-icon.png" width="16px" height="16px">
          </div>
          <div class="city-name">
            <span>{{ data.departureCode }}</span>
            <span>{{ data.destinationCode }}</span>
          </div>
        </div>
        <div v-if="data.orderServiceType==4" class="start-end">
          <div class="city-name-top" style="width: 70%;margin-left: 40px;">
            <span>{{ data.departureCode }}</span>
            <span><img src="@/assets/img/client/check/Air.png" style="width: 24px;"></span>
            <span>{{ data.destinationCode }}</span>
            <span><img class="package-img" src="@/assets/img/client/chat/car.png" width="24px"
            height="24px"></span>
          </div>
          <div class="route">
            <img src="@/assets/img/client/booking/dian-icon.png" width="16px" height="16px">
            <div class="line" style="width: 280px;margin: 7px 10px 0;border-style: solid" />
            <img src="@/assets/img/client/booking/dian-icon.png" width="16px" height="16px">
            <div class="line" style="width: 280px;margin: 7px 10px 0;" />
            <img src="@/assets/img/client/booking/dian-icon.png" width="16px" height="16px">
          </div>
          <div class="city-name">
            <span></span>
            <span>{{ GetDestAddress() }}</span>
          </div>
        </div>
        <div class="order-info">
          <div class="order-info-l">
            <div><img src="@/assets/img/client/check/Air.png" style="width: 32px;"></div>
            <div>Air</div>
            <div>{{ getType() }}</div>
          </div>
          <div class="order-info-r">
            <div>Est. transit time from pickup: {{ data.validTerm }} days</div>
            <div>Goods Ready:{{ data.planDeliveryTime }}</div>
          </div>
        </div>
        <div class="volume-info">
          <div class="volume-info-l">
            <div class="title">Load</div>
            <div class="load-class">
              <div class="number">{{ data.quantity }}</div>
              <span>✖</span>
              <div class="size">
                <div>Boxes/Crates</div>
                <div>Boxes</div>
              </div>
            </div>
          </div>
          <div class="volume-info-r">
            <div class="title">Total weight/volume</div>
            <div class="size">
              <div>{{ data.weight }} KG</div>
              <div>{{ data.volumeCbm }} CBM</div>
            </div>
          </div>
        </div>
        <div class="last-info">
          <div class="carrier" v-if="data.airSupplierCode">
            <div class="title">Customs broker</div>
            <img :src="data.airSupplierLogo" alt="airsupplier logo" width="159px" height="56px">
          </div>
          <div v-if="data.isrInsurance" class="insurance">
            <div class="title">Insurance</div>
            <img v-if="data.insuranceLogo" :src="data.insuranceLogo" width="159px" height="56px">
          </div>
        </div>
        <div class="tip-info">
          <img src="@/assets/img/manage/ic_warning@2x.png" width="16px" height="16px">
          <span>
            `This rate is valid until {{ data.queryValidTerm }}. If your goods are not loaded onto a vessel by this
            date, or if the actual Shipment load differs from the Quote, the rate may be subject to an adjustment in
            line with the marketplace rate.`
          </span>
        </div>
        <div class="footer-button">
          <button class="by-button--primary" @click="clickConfirm">Confirm & Book Shipment</button>
        </div>
      </div>
      <div class="content-r">
        <div class="price-detalls-bg">
          <span>Price detalls</span>
        </div>
        <div class="price-detalls">
          <div class="detalls-item">
            <div>Quote</div>
            <div>¥{{ data.costAmount }}</div>
          </div>
          <div v-if="otherAmount > 0" class="detalls-item">
            <div>Customs brokerage and bond</div>
            <div>CNY{{ otherAmount }}</div>
          </div>
          <div class="detalls-item">
            <div>Duties and taxes</div>
            <div>Not Included</div>
          </div>
          <div class="detalls-list">
            <div v-if="data.isrInsurance" class="detalls-item">
              <div>Insurance</div>
              <div>CNY{{ data.insuranceAmount }}</div>
            </div>
            <div class="left">Based on value of ${{ data.goodsValue }}</div>
          </div>
          <div class="line" />
          <div class="detalls-Total">
            <div>Total</div>
            <div>CNY{{ data.totalAmount }}</div>
          </div>
        </div>
      </div>
    </div>
    <ConfirmOrder ref="ConfirmOrder" v-if="isConfirmOrder" @close="() => { isConfirmOrder = false }" />
  </div>
</template>

<script>
import ConfirmOrder from './confirmOrder.vue'
import Steps from '../../steps.vue'
import define from '@/utils/define'
import { GetAirOrderDetail } from '@/api/order.js'
export default {
  name: 'Index',
  components: {
    // 组件的引用
    Steps, ConfirmOrder
  },
  props: {
    // 父辈向子辈传参
  },
  data () {
    return {
      active: 3,
      isConfirmOrder: false,
      data: null,
      otherAmount: 0,//其他費用
    }
  },
  computed: {
    // 计算属性
  },
  watch: {
    // 监测变化
  },
  created () {
    const orderNo = this.$route.query.orderNo;
    this.GetAirDetail(orderNo);
  },
  mounted () {
    // 页面进入时加载内容
  },
  methods: {
    // 方法
    clickConfirm () {
      this.isConfirmOrder = true
      this.$nextTick(() => {
        console.log(this.$refs.ConfirmOrder)
        this.$refs.ConfirmOrder.init(this.data)
      })
    },
    GetOriginAddress () {
      switch (this.data.orderServiceType) {
        case 1:
        case 2:
          return `${this.data.startCityNameEn},${this.data.startCityZipCode}`
      }
    },
    GetDestAddress () {
      switch (this.data.orderServiceType) {
        case 1:
        case 4:
          return `${this.data.destCityNameEn},${this.data.destCityZipCode}`
      }
    },
    getType () {
      switch (this.data.orderServiceType) {
        case 1:
          return 'Door to Door'
        case 2:
          return 'Door to Airport'
        case 3:
          return 'Airport to Airport'
        case 4:
          return 'Airport to Door'
      }
    },
    GetAirDetail (orderNo) {
      GetAirOrderDetail(orderNo).then(res => {
        if (res.code === 200) {
          this.data = res.data;
          if (this.data.airSupplierLogo != null) {
            this.data.airSupplierLogo = define.comUrl + this.data.airSupplierLogo;
          }
          if (this.data.insuranceLogo) {
            this.data.insuranceLogo = define.comUrl + this.data.insuranceLogo
          } else {
            this.data.insuranceLogo = undefined
          }
          this.data.feeList.forEach(item => {
            this.otherAmount += item.Amount
          })
          if (this.data.bondAmount) {
            this.otherAmount += this.data.bondAmount
          }
          if (this.data.startLiftgateAmount) {
            this.otherAmount += this.data.startLiftgateAmount
          }
          if (this.data.destLiftgateAmount) {
            this.otherAmount += this.data.destLiftgateAmount
          }
          if (this.data.deliveryAmount) {
            this.otherAmount += this.data.deliveryAmount
          }
          if (this.data.pickupAmount) {
            this.otherAmount += this.data.pickupAmount
          }
        }
      })
    }
  }
}
</script>
<style scoped lang='scss'>
.flex1 {
  display: flex;
  justify-content: space-between;
}

.font-class {
  font-size: 13px;
  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  color: #333333;

  div:nth-of-type(1) {
    font-weight: 600;
  }
}

.title-class {
  font-size: 13px;
  font-family: PingFangSC, PingFang SC;
  font-weight: 600;
  color: #333333;
  height: 40px;
  text-align: left;
  line-height: 40px;
}

.index {
  margin: 0 auto;
  width: 1200px;

  .Steps-main {
    padding-top: 40px;
  }

  .booking-title {
    height: 32px;
    text-align: left;
    margin: 20px 0;

    span:nth-of-type(1) {
      color: #e95506;
      margin-right: 12px;
    }

    span:nth-of-type(2) {
      font-size: 18px;
      font-family: PingFangSC, PingFang SC;
      font-weight: 600;
      color: #333333;
    }
  }

  .booking-content {
    display: flex;

    .content-l {
      width: 894px;

      .start-end {
        width: 894px;
        height: 152px;
        background: #ffffff;
        border-radius: 8px;

        .package-img {
          margin-top: 32px;
        }

        .route {
          display: flex;
          justify-content: center;

          .line {
            width: 647px;
            height: 0px;
            border: 2px dashed rgba(2, 127, 252, 0.8);
            margin-top: 7px;
          }
        }
        .city-name-top {
          display: flex;
    -webkit-box-pack: justify;
    -ms-flex-pack: justify;
    justify-content: space-evenly;
    padding: 16px;
          align-items: flex-end;
          width: 60%;
          margin: 0 auto;

          span {
            display: inline-block;
            width: 215px;
            font-size: 13px;
            font-family: PingFangSC, PingFang SC;
            font-weight: 600;
            color: #333333;
          }
        }
        .city-name {
          display: flex;
          justify-content: space-between;
          padding: 16px;

          span {
            display: inline-block;
            width: 215px;
            font-size: 13px;
            font-family: PingFangSC, PingFang SC;
            font-weight: 600;
            color: #333333;
          }
        }
      }

      .order-info {
        margin: 16px 0;
        @extend .flex1;

        .order-info-l {
          width: 286px;
          height: 36px;
          background: #ffffff;
          border-radius: 8px;
          margin-right: 16px;
          padding: 10px 0;
          @extend .font-class;
        }

        .order-info-r {
          width: 592px;
          height: 88px;
          background: #ffffff;
          border-radius: 8px;
          text-align: left;

          div {
            margin: 16px;
            font-size: 14px;
            font-family: PingFangSC, PingFang SC;
            font-weight: 400;
            color: #333333;
          }
        }
      }

      .volume-info {
        @extend .flex1;
        margin: 16px 0;

        .volume-info-l {
          width: 564px;
          height: 112px;
          background: #ffffff;
          border-radius: 8px;
          margin-right: 8px;
          padding: 0 16px;

          .title {
            @extend .title-class;
          }

          .load-class {
            display: flex;
            align-items: center;

            .number {
              width: 38px;
              height: 56px;
              background: rgba(233, 85, 6, 0.04);
              border-radius: 8px;
              line-height: 56px;
            }

            span {
              margin: 0 8px;
            }

            .size {
              width: 498px;
              height: 36px;
              background: rgba(233, 85, 6, 0.04);
              border-radius: 8px;
              text-align: left;
              padding: 10px 16px;
              @extend .font-class;
            }
          }
        }

        .volume-info-r {
          width: 290px;
          height: 112px;
          background: #ffffff;
          border-radius: 8px;
          padding: 0 16px;

          .title {
            @extend .title-class;
          }

          .size {
            width: 258px;
            height: 36px;
            background: rgba(233, 85, 6, 0.04);
            border-radius: 8px;
            padding: 10px 0;
            @extend .font-class;
          }
        }
      }

      .last-info {
        @extend .flex1;
        margin: 16px 0;

        .carrier {
          width: 443px;
          height: 112px;
          background: #ffffff;
          border-radius: 8px;
          margin-right: 8px;
          padding: 0 16px;

          .title {
            @extend .title-class;
          }
        }

        .insurance {
          width: 443px;
          height: 112px;
          background: #ffffff;
          border-radius: 8px;
          padding: 0 16px;

          .title {
            @extend .title-class;
          }
        }
      }

      .tip-info {
        margin: 8px 0px;
        display: flex;
        width: 878px;
        //height: 54px;
        background: rgba(2, 127, 252, 0.04);
        border-radius: 4px;
        font-size: 13px;
        font-family: PingFangSC, PingFang SC;
        font-weight: 400;
        color: #027ffc;
        padding: 8px;
        text-align: left;

        img {
          margin-right: 8px;
        }
      }

      .footer-button {
        margin: 24px 0;

        button {
          width: 400px;
          height: 40px;
        }
      }
    }

    .content-r {
      width: 282px;
      margin-left: 24px;

      .price-detalls-bg {
        width: 282px;
        height: 88px;
        background: url("../../../../assets/img/client/booking/background_color.png");
        background-size: 282px 88px;
        text-align: left;
        line-height: 47px;

        span {
          font-size: 18px;
          font-family: PingFangSC, PingFang SC;
          font-weight: 600;
          color: #ffffff;
          margin: 16px;
        }
      }

      .price-detalls {
        width: 250px;
        min-height: 188px;
        background: #ffffff;
        border-radius: 8px;
        position: relative;
        top: -40px;
        padding: 0 16px;

        .detalls-item,
        .detalls-Total {
          display: flex;
          justify-content: space-between;
          align-items: center;
          height: 40px;
        }

        .detalls-item {
          font-size: 13px;
          font-family: PingFangSC, PingFang SC;
          font-weight: 400;
          color: #333333;
        }

        .detalls-Total {
          font-size: 16px;
          font-family: PingFangSC, PingFang SC;
          font-weight: 600;
          color: #333333;
        }

        .line {
          width: 250px;
          height: 0px;
          border: 1px dashed #dddddd;
          margin: 8px 0;
        }

        .detalls-list {
          .detalls-item {
            @extend .detalls-item;
          }

          .left {
            text-align: left;
            color: #777777;
          }
        }
      }
    }
  }
}
</style>
